import { render, staticRenderFns } from "./PastTrips.vue?vue&type=template&id=62635170&scoped=true&"
import script from "./PastTrips.vue?vue&type=script&lang=js&"
export * from "./PastTrips.vue?vue&type=script&lang=js&"
import style0 from "./PastTrips.vue?vue&type=style&index=0&id=62635170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62635170",
  null
  
)

export default component.exports